import { WidgetDefinition } from '../models/WidgetDefinition';

export const SpotManualInputsWidgetDefinition: WidgetDefinition = {
    baseType: 'SpotManualInputs',
    group: 'Charts',
    hasImage: true,
    highlights: ['Spot manual input identifiers of selected group'],
    icon: 'fa-map-pin',
    sortingOrder: -50,
    title: 'Spot manual inputs',
    type: 'SpotManualInputs'
};